import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z"
}), 'ViewQuilt');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewQuilt.js
// module id = 7115
// module chunks = 2